
<n-slide-window
    id="batchConfigSlide"
    width="9rem"
    [visible]="isBatchConfigShow"
    [showMask]="true"
    (onHide)="onHide()">

    <!-- 侧滑窗标题区 -->
    <n-header>
        <h1>
            {{i18n.title}}
            <n-help-link key="storagesysBatchConfig"></n-help-link>
        </h1>
    </n-header>

    <!-- 侧滑窗内容区 -->
    <n-tab style="height: 100%;" [hideHeader]="true">
        <n-tab-item>
            <div class="box">
                <div class="form-box">
                    <span [innerHTML]="i18n.explanation"></span>
                    <a (click)="downloadFile()">
                        {{i18n.sysInfoAndScriptTemplate}}
                    </a>
                    <span [innerHTML]="isOem ?i18nService.language === 'ja'? ' is recommended. Then, edit, upload, and execute it.\<br/>2. You can ': i18n.importAndExecuteOem : i18n.importAndExecute"></span>
                    <a (click)="clearConfigExecute()">
                        {{i18n.deleteByHand}}
                    </a>
                    <span [innerHTML]="i18n.deleteByHandTip"></span>
                    <n-row class="button-area" [gutter]="20">
                        <n-col>
                            <span class="label">
                                {{i18n.serviceConfigurationFile}}
                            </span>
                        </n-col>
                        <n-col class="upload-wrapper">
                            <p-fileUpload #cliUploader
                                name="file[]"
                                [url]="uploadURL"
                                (onValidateError)="onValidateError()"
                                (onBeforeUpload)="onBeforeUpload()"
                                (onBeforeSend)="onBeforeSend($event)"
                                (onUploading)="onUploading($event)"
                                (onUpload)="onUpload($event)"
                                (onPaused)="onPaused()"
                                (onError)="onError($event)"
                                (onClear)="onClear()"
                                (onHistoryClear)="onHistoryClear()"
                                (onRemove)="onRemove()"
                                (onHistoryRemove)="onHistoryRemove()"
                                (onSelect)="onSelectPatch($event, cliUploader, onSelect)"
                                [disabled]="!enableImportFile"
                                [accept]="acceptFileType"
                                [allowFileSuffix]="allowFileSuffix"
                                [maxFileSize]="maxFileSize"
                                [resume]="false"
                                uploadButtonVisible=true
                                [showUploadStatus]="'upload'===currentStatusBar"
                                [statusFailedLabel]="statusFailedLabel"
                                cancelLabel=""
                                [containerStyle]="{'max-width':'3.8rem'}">
                            </p-fileUpload>

                            <!-- 校验状态栏 -->
                            <div *ngIf="'check'===currentStatusBar"
                                class="progress-area ui-fileupload-status">
                                <span class="ui-fileupload-status-text ng-star-inserted">
                                    <svg class="icon uploading">
                                        <use xlink:href="#icon-loading">
                                        </use>
                                    </svg>
                                    {{i18n.importVerifying}}
                                </span>
                            </div>
                        </n-col>
                        <n-col class="execute-button-wrap">
                            <button nButton
                                theme="primary"
                                (click)="checkBeforeExecute()"
                                [disabled]="!enableExcuteButton"
                                [label]="i18n.execute">
                            </button>
                        </n-col>
                    </n-row>

                    <!-- 执行状态栏 -->
                    <n-row *ngIf="'executing'===currentStatusBar"
                        class="progress-area">
                        <div class="ui-fileupload-status">
                            <span class="ui-fileupload-status-text ng-star-inserted" *ngIf="!enableContinueBtn">
                                <svg class="icon uploading">
                                    <use xlink:href="#icon-loading">
                                    </use>
                                </svg>
                                {{i18n.executing}}
                            </span>
                            <span class="ui-fileupload-status-text ng-star-inserted" *ngIf="enableContinueBtn">
                                <svg class="icon">
                                    <use xlink:href="#app-icon-icon-bc-pause">
                                    </use>
                                </svg>
                                {{i18n.pause}}
                            </span>
                        </div>
                        <p-progressBar
                            [value]="cliProgress"
                            class="progress-bar">
                        </p-progressBar>
                        <a
                            (click)="cliStop()"
                            class="stop-btn">
                            {{i18n.stop}}
                        </a>
                        <a
                            (click)="cliContinue()"
                            class="continue-btn"
                            *ngIf="enableContinueBtn">
                            {{i18n.continue}}
                        </a>
                    </n-row>

                    <!-- 执行完成状态栏 -->
                    <n-row *ngIf="'executed'===currentStatusBar"
                        class="progress-area">
                        <div class="ui-fileupload-status">
                            <span class="ui-fileupload-status-text ng-star-inserted">
                                <svg class="icon completed">
                                    <use xlink:href="#icon-status-succeed">
                                    </use>
                                </svg>
                                {{i18n.result}}
                            </span>
                        </div>
                    </n-row>
                </div>
                <div *ngIf="!notImported && fileResult && currentStatusBar === 'upload'"
                    class="show-detail-code">
                    <span>
                        <svg class="icon code-tip">
                            <use xlink:href="#icon-status-info">
                            </use>
                        </svg>
                        {{i18n.configFilePreviewTips}}
                    </span>
                    <div style="margin-left: 20px;">
                        {{i18n.previewBtn}}
                        <n-switch id="config-code-detail-switch"
                            class="code-detail-switch"
                            [(ngModel)]="isShowDetailCode"
                            (onChange)="showDetailCode($event)">
                        </n-switch>
                    </div>
                </div>
                <div class="result-box">
                    <div *ngIf="cliEchoArr.length > 0"
                        class="log-area log-line">
                        <div *ngFor="let echo of cliEchoArr">
                            <div>
                                {{echo}}
                            </div>
                        </div>
                    </div>

                    <div *ngIf="errorLineArr.length > 0"
                        class="log-area log-line">
                        <div *ngFor="let log of errorLineArr">
                            <div *ngIf="log.command">
                                {{log.command}}
                            </div>
                            <span *ngIf="log.errorLine" class="error-line">
                                    errorLine: {{log.errorLine}}
                            </span>
                        </div>
                    </div>

                    <div *ngIf="!(errorLineArr.length > 0 || cliEchoArr.length > 0)"
                        [ngClass]="notImported || !isShowDetailCode ? 'import-illustration' : 'log-area log-line'">
                        <div *ngIf="notImported"
                            class="not-import-status-icon">
                            <svg class="icon icon-size-lg">
                                <use xlink:href="#app-icon-config-file-not-exist">
                                </use>
                            </svg>
                            <p class="import-status-label">
                                {{i18n.notImport}}
                            </p>
                        </div>
                        <div *ngIf="!notImported && isShowDetailCode">
                            <div style="white-space: pre-wrap;">{{fileResult}}</div>
                        </div>
                        <div *ngIf="!notImported && !isShowDetailCode"
                            class="import-status-icon">
                            <svg class="icon icon-size-48">
                                <use xlink:href="#app-icon-import-config-succeed">
                                </use>
                            </svg>
                            <p class="import-status-label mt-20">
                                {{i18n.succImport}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </n-tab-item>
    </n-tab>

    <!-- 侧滑窗底部按钮区 -->
    <n-footer>
        <div class="slide-botton-group">
            <button
                pButton
                type="button"
                (click)="hideSlideWindow()"
                [disabled]="disableCloseBtn"
                [label]="i18n.close">
            </button>
        </div>
    </n-footer>
</n-slide-window>
